import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Items/Navbar";
import useVerify from "./useVerify";
import { MdArrowBackIos } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";

function List() {
  useVerify("user");

  const navigate = useNavigate();
  const [quizs, setQuizs] = useState([]);

  const [query, setQuery] = useState("");

  useEffect(() => {
    fetchAllQuizs(query);

    // eslint-disable-next-line
  }, []);

  async function fetchAllQuizs(key) {
    let uri = "";
    if (key === "") uri = `${process.env.REACT_APP_BASE_URL}/api/quizs`;
    else uri = `${process.env.REACT_APP_BASE_URL}/api/quizs/${key}`;

    await fetch(uri)
      .then((response) => response.json())
      .then((data) => {
        setQuizs(data);
      });
  }

  const handleSearch = (event) => {
    setQuery(event.target.value);
    fetchAllQuizs(event.target.value);
  };

  return (
    <div className="w-full h-screen bg-slate-300">
      <Navbar />
      <div className="w-full h-full flex justify-center items-center mt-12 bg-slate-300">
        <div className="w-2/3 h-full mb-20 mt-12">
          <div className="flex flex-row justify-start items-center">
            <button onClick={() => navigate(-1)} className="text-black/90">
              <MdArrowBackIos className="text-4xl"></MdArrowBackIos>
            </button>
            <h1 className="text-4xl font-extrabold mb-1 text-black/90">
              Pilih Tes
            </h1>
          </div>

          <form className="mt-8">
            <label
              for="default-search"
              class="mb-2 text-sm font-medium text-gray-900 sr-only"
            >
              Search
            </label>
            <div class="relative">
              <input
                type="search"
                id="default-search"
                class="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-slate-50 "
                placeholder="Cari Tes ..."
                value={query}
                onChange={handleSearch}
                required
              />
              <button
                type="submit"
                class="text-white absolute right-2.5 bottom-2.5 bg-[#FF914D] hover:bg-[#e8742b] focus:ring-4  font-medium rounded-lg text-sm px-4 py-2"
              >
                <AiOutlineSearch className="text-xl"></AiOutlineSearch>
              </button>
            </div>
          </form>

          <div className="w-full h-4/5 mt-8 overflow-auto gap-6 grid grid-cols-1 md:grid-cols-2">
            {quizs.map((quiz) => (
              <div
                key={quiz.quizId}
                className="flex flex-col justify-center bg-gradient-to-br from-slate-200 h-52 to-blue-200 items-start p-6 rounded-lg shadow-xl"
              >
                <div>
                  <h3 className="text-xl uppercase font-bold text-[#393939]">
                    {quiz.quizName}
                  </h3>
                  <div className="mt-4">
                    <div className="flex flex-row items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4 text-blue-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <p className="text-[#393939] text-sm ml-2">
                        1 menit / kolom
                      </p>
                    </div>
                    <div className="flex flex-row items-center mt-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4 text-blue-700"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                        />
                      </svg>

                      <p className="text-[#393939] text-sm ml-2">
                        {quiz.jumlahKoloms} kolom
                      </p>
                    </div>
                  </div>

                  <div>
                    <Link to={`/countdown/${quiz.quizId}`}>
                      <button
                        className="text-sm tracking-wide rounded py-2 px-4 mt-4 bg-[#FF914D] text-white hover:bg-[#e8742b]
                      transition duration-500 ease-in-out shadow-xl"
                      >
                        Mulai Tes
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default List;
